// first category image
import firstCategory1 from "../images/firstcategory1.webp";
import firstCategory2 from "../images/firstcategory2.webp";
import firstCategory3 from "../images/firstcategory3.webp";
import firstCategory4 from "../images/firstcategory4.webp";
import firstCategory5 from "../images/firstcategory5.webp";
import firstCategory6 from "../images/firstcategory6.webp";
// first category image

// second category image
import secondCategory1 from "../images/secondCategory1.webp";
import secondCategory2 from "../images/secondCategory2.webp";
import secondCategory3 from "../images/secondCategory3.webp";
import secondCategory4 from "../images/secondCategory4.webp";
import secondCategory5 from "../images/secondCategory5.webp";
import secondCategory6 from "../images/secondCategory6.webp";
// second category image

export const firstCategories = [
  { img: firstCategory1, text: "Automobile" },
  { img: firstCategory2, text: "Car" },
  { img: firstCategory3, text: "Fashion" },
  { img: firstCategory4, text: "Mobile" },
  { img: firstCategory5, text: "Laptop" },
  { img: firstCategory6, text: "Desktop" },
  { img: secondCategory1, text: "Tablet" },
  { img: secondCategory2, text: "Fashion" },
  { img: secondCategory3, text: "Electronics" },
  { img: secondCategory4, text: "Furniture" },
  { img: secondCategory5, text: "Camera" },
  { img: secondCategory6, text: "Electronics" },
];

